// extracted by mini-css-extract-plugin
module.exports = {"root":"IconAward_root__1Lekv"};